import React, { useState } from 'react';
import { LanguageProvider, useLanguage } from './LanguageProvider';
import NavbarLanguageSelector from './components/NavbarLanguageSelector';
import MobileMenu from './components/MobileMenu';
import Modal from './Modal';
import AffiliateTextSection from './components/AffiliateTextSection';
import KapcsolatForm from './components/KapcsolatForm';
import Affiliate from './pages/Affiliate';
import AffiliateRegister from "./pages/AffiliateRegister";
import AffiliateAuthModal from "./components/AffiliateAuthModal";
import AffiliateDashboardPage from './pages/AffiliateDashboard';
import AdminDashboard from "./pages/AdminDashboard";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";
import AdminPromoReports from "./pages/AdminPromoReports";
import AdvancedUserManagement from "./pages/AdvancedUserManagement";
import PropertyUpload from './pages/PropertyUpload';
import PropertyListings from './pages/PropertyListings';
import PropertySuccess from './pages/PropertySuccess';
import PropertyLandingPage from './pages/PropertyLandingPage';
import EpitkezesFlow from './pages/EpitkezesFlow';
import TelekFlow from './pages/TelekFlow';
import HOPPHomesHome from './pages/HOPPHomesHome';
import GatewayBlocks from './components/hopphomes/GatewayBlocks';
import HOPPyAIChat from './components/hopphomes/HOPPyAIChat';
import ActivityTracker from './components/ActivityTracker';
import UserAuthMenu from './components/UserAuthMenu';
import { ProtectedAffiliateRoute, ProtectedAdminRoute } from "./auth-routes.jsx";
import TopCTA from './components/TopCTA';
import OfferRequestModal from './components/OfferRequestModal';
import SzemelyreSzabott from './components/SzemelyreSzabott';
import Negyevszakos from './components/Negyevszakos';
import HelysziniElo from './components/HelysziniElo';
import MiertModuLive from './pages/MiertModuLive';
import MiertHoppHomes from './pages/MiertHoppHomes';
import MitTartalmaz from './pages/MitTartalmaz';
import Impresszum from './pages/Impresszum';
import JogiNyilatkozat from './pages/JogiNyilatkozat';
import KapcsolatOldal from './pages/KapcsolatOldal';
import KeszHazak from './pages/KeszHazak';
import Ajanlat from './pages/Ajanlat';
import HoppSolid from './pages/HoppSolid';
import KeszHazModel from './pages/KeszHazModel';
import EgyediHazak from './pages/EgyediHazak';
import MobilhazakPage from './pages/MobilhazakPage';
import IngatlanPiac from './pages/IngatlanPiac';
import HoppProConcept from './pages/HoppProConcept';
import HoppProConceptModel from './pages/HoppProConceptModel';
import HoppProConceptViablokk from './pages/HoppProConceptViablokk';
import AIPropertyTransform from './pages/AIPropertyTransform';
import InvestorDashboard from './components/InvestorDashboard';
import HamarosaanPage from './pages/HamarosaanPage';
import Top5ProjectsWeekly from './components/Top5ProjectsWeekly';
import HotDealsSection from './components/secretdeals/HotDealsSection';
import MaintenancePage from './components/MaintenancePage';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './index.css';
import './mobile-fixes.css';
import './mobile-optimizations.css';
import './assets/aos.css';
import './styles/slider.css';
import { useEffect } from 'react';
import { initAOS } from './utils/aos';
import SocialIcons from './components/SocialIcons';
import TiktokPromoBlock from './components/TiktokPromoBlock';
import VideoGalleryPromoBlock from './components/VideoGalleryPromoBlock';
import VideoGalleryModal from './components/VideoGalleryModal';
import ArKalkulatorModalContent from './components/ArKalkulatorModalContent';
import MuszakiModalContent from './components/MuszakiModalContent';
import KiemeltTipusok from './components/KiemeltTipusok';
import MuszakiInfoBlokk from './components/MuszakiInfoBlokk';
import AffiliateBlokk from './components/AffiliateBlokk';
import Footer from './components/Footer';
import AjanloiProgramUjRegisztracioModal from './components/AjanloiProgramUjRegisztracioModal';
import HeroSection from './components/HeroSection';
import PlatformHero from './components/PlatformHero';
import SolutionsSection from './components/SolutionsSection';
import WhyUsSection from './components/WhyUsSection';
import PricingSection from './components/PricingSection';
import GallerySection from './components/GallerySection';
import VideoTestimonialsSection from './components/VideoTestimonialsSection';
import AffiliateSection from './components/AffiliateSection';
import OfferFormSection from './components/OfferFormSection';
import BlogSection from './components/BlogSection';
import ContactSection from './components/ContactSection';
import OtthonStartBanner from './components/OtthonStartBanner';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import StatsSection from './components/StatsSection';
import MobileBottomNav from './components/MobileBottomNav';
import DarkLayout from './components/layout/DarkLayout';
import MobileHeaderAnimation from './components/MobileHeaderAnimation';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db, auth } from './firebase-config';

function Icon({children}) {
  return <span className="inline-flex items-center justify-center text-4xl md:text-5xl text-white mb-2">{children}</span>;
}


function Header({ onMuszakiModalOpen, onModalOpen, onArKalkulatorOpen, onMobileMenuOpen, showAffiliateSection, setShowAffiliateSection }) {
  const { dict } = useLanguage();
  const [keszHazakOpen, setKeszHazakOpen] = React.useState(false);
  const [hazakOpen, setHazakOpen] = React.useState(false);
  const [eszkozokOpen, setEszkozokOpen] = React.useState(false);
  
  return (
    <header className="sticky top-0 z-30 w-full py-3 bg-gradient-to-b from-black via-[#0a0a0a] to-black/95 backdrop-blur-xl border-b border-white/20 shadow-2xl shadow-black/50">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="relative flex items-center justify-between min-h-[4rem] w-full bg-gradient-to-r from-[#1a1a1a] via-[#2a2a2a] to-[#1a1a1a] rounded-2xl px-4 py-2 border-2 border-white/10 shadow-xl">
        
        {/* HoppHomes Logo */}
        <Link to="/" className="flex items-center h-full z-10 flex-shrink-0 group relative">
          <div className="absolute inset-0 bg-gradient-to-r from-secondary/20 to-transparent rounded-xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <img src="/logo_ai.png" alt="HoppHomes logó" className="h-10 md:h-12 p-0 transition-transform duration-300 group-hover:scale-110 relative z-10" />
        </Link>
        
        {/* Mobile Header Animation - Between logo and hamburger */}
        <MobileHeaderAnimation />
        
        {/* Navigation buttons - Hidden on mobile/tablet */}
        <div className="hidden xl:flex items-center justify-center gap-1.5 py-2 flex-1 mx-2">
          
          {/* HOPPHomes Menu Items - Compact */}
          <Link to="/telek" className="px-3 py-2 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-cyan-600 hover:to-blue-600 text-white font-bold text-xs rounded-lg transition-all duration-300 whitespace-nowrap no-underline hover:scale-105">
            🗺️ Telek
          </Link>
          
          <Link to="/epitkezes" className="px-3 py-2 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-emerald-600 hover:to-green-600 text-white font-bold text-xs rounded-lg transition-all duration-300 whitespace-nowrap no-underline hover:scale-105">
            🏗️ Építkezés
          </Link>
          
          <Link to="/property-upload" className="px-3 py-2 bg-gradient-to-r from-red-600 to-orange-600 hover:from-orange-600 hover:to-red-600 text-white font-bold text-xs rounded-lg transition-all duration-300 whitespace-nowrap no-underline hover:scale-105">
            🏠 Eladás
          </Link>
          
          <Link to="/elado-ingatlanok" className="px-3 py-2 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-pink-600 hover:to-purple-600 text-white font-bold text-xs rounded-lg transition-all duration-300 whitespace-nowrap no-underline hover:scale-105">
            🏘️ Ingatlanok
          </Link>
          
          <Link to="/hot-deals" className="px-3 py-2 bg-gradient-to-r from-red-600 via-orange-500 to-red-600 hover:from-red-500 hover:via-orange-400 hover:to-red-500 text-white font-bold text-xs rounded-lg transition-all duration-300 whitespace-nowrap no-underline hover:scale-105 animate-pulse shadow-lg shadow-red-500/30">
            🔥 HOT DEALS
          </Link>
          
          {/* Házak dropdown - GROUPED */}
          <div className="relative">
            <button 
              className="group px-3 py-2 bg-gradient-to-r from-secondary to-red-600 hover:from-red-600 hover:to-secondary text-white font-bold text-xs rounded-lg transition-all duration-300 whitespace-nowrap flex items-center gap-1.5 hover:scale-105"
              onClick={() => setHazakOpen(!hazakOpen)}
              type="button"
            >
              🏠 Házak
              <svg className={`w-3 h-3 transition-transform duration-300 ${hazakOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {hazakOpen && (
              <div className="absolute top-full left-0 mt-2 bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] border border-white/20 rounded-2xl shadow-2xl shadow-black/50 z-50 min-w-[240px] backdrop-blur-xl overflow-hidden">
                <Link to="/egyedi-hazak" onClick={() => setHazakOpen(false)} className="group block px-5 py-3 text-white text-sm hover:bg-gradient-to-r hover:from-secondary/20 hover:to-red-600/20 transition-all font-bold flex items-center gap-2">
                  <span>🏗️</span>
                  <span className="group-hover:translate-x-1 transition-transform">Egyedi házak</span>
                </Link>
                <Link to="/mobilhazak" onClick={() => setHazakOpen(false)} className="group block px-5 py-3 text-white text-sm hover:bg-gradient-to-r hover:from-secondary/20 hover:to-red-600/20 transition-all flex items-center gap-2">
                  <span>🚐</span>
                  <span className="group-hover:translate-x-1 transition-transform">Mobilházak</span>
                </Link>
                <Link to="/hopp-proconcept" onClick={() => setHazakOpen(false)} className="group block px-5 py-3 text-white text-sm hover:bg-gradient-to-r hover:from-secondary/20 hover:to-red-600/20 transition-all font-bold flex items-center gap-2">
                  <span>🏗️</span>
                  <span className="group-hover:translate-x-1 transition-transform">Hopp ProConcept</span>
                </Link>
                <div className="border-t border-white/20 my-2"></div>
                <div className="px-5 py-2 text-gray-400 text-xs font-black tracking-wider">KÉSZ HÁZAK</div>
                <Link to="/kesz-hazak" onClick={() => setHazakOpen(false)} className="group block px-5 py-3 text-white text-sm hover:bg-gradient-to-r hover:from-secondary/20 hover:to-red-600/20 transition-all flex items-center gap-2">
                  <span className="group-hover:translate-x-1 transition-transform">Összes modell</span>
                </Link>
                <Link to="/kesz-hazak/lucara" onClick={() => setHazakOpen(false)} className="group block px-5 py-2.5 text-gray-300 text-sm hover:bg-gradient-to-r hover:from-secondary/20 hover:to-red-600/20 transition-all pl-8 flex items-center gap-2">
                  <span className="group-hover:translate-x-1 transition-transform">HH Lucara</span>
                </Link>
                <Link to="/kesz-hazak/nativi" onClick={() => setHazakOpen(false)} className="group block px-5 py-2.5 text-gray-300 text-sm hover:bg-gradient-to-r hover:from-secondary/20 hover:to-red-600/20 transition-all pl-8 flex items-center gap-2">
                  <span className="group-hover:translate-x-1 transition-transform">HH Nativi</span>
                </Link>
                <Link to="/kesz-hazak/martino" onClick={() => setHazakOpen(false)} className="group block px-5 py-2.5 text-gray-300 text-sm hover:bg-gradient-to-r hover:from-secondary/20 hover:to-red-600/20 transition-all pl-8 flex items-center gap-2">
                  <span className="group-hover:translate-x-1 transition-transform">HH Martino</span>
                </Link>
                <Link to="/kesz-hazak/verona" onClick={() => setHazakOpen(false)} className="group block px-5 py-2.5 text-gray-300 text-sm hover:bg-gradient-to-r hover:from-secondary/20 hover:to-red-600/20 transition-all pl-8 flex items-center gap-2">
                  <span className="group-hover:translate-x-1 transition-transform">HH Verona</span>
                </Link>
                <Link to="/kesz-hazak/kate" onClick={() => setHazakOpen(false)} className="group block px-5 py-2.5 text-gray-300 text-sm hover:bg-gradient-to-r hover:from-secondary/20 hover:to-red-600/20 transition-all pl-8 flex items-center gap-2">
                  <span className="group-hover:translate-x-1 transition-transform">HH Kate</span>
                </Link>
              </div>
            )}
          </div>
          
          {/* AI & Eszközök dropdown - GROUPED */}
          <div className="relative">
            <button 
              className="group px-3 py-2 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-500 hover:to-emerald-500 text-white font-bold text-xs rounded-lg transition-all duration-300 whitespace-nowrap flex items-center gap-1.5 hover:scale-105"
              onClick={() => setEszkozokOpen(!eszkozokOpen)}
              type="button"
            >
              🤖 AI
              <svg className={`w-3 h-3 transition-transform duration-300 ${eszkozokOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {eszkozokOpen && (
              <div className="absolute top-full left-0 mt-2 bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] border border-white/20 rounded-2xl shadow-2xl shadow-black/50 z-50 min-w-[240px] backdrop-blur-xl overflow-hidden">
                <Link to="/ai-transform" onClick={() => setEszkozokOpen(false)} className="group block px-5 py-3 text-white text-sm hover:bg-gradient-to-r hover:from-green-600/20 hover:to-emerald-600/20 transition-all font-bold flex items-center gap-2">
                  <span>🤖</span>
                  <span className="group-hover:translate-x-1 transition-transform">AI Transform</span>
                  <span className="text-xs bg-green-600 px-2 py-0.5 rounded-full ml-auto">AI</span>
                </Link>
                <Link to="/befekteto" onClick={() => setEszkozokOpen(false)} className="group block px-5 py-3 text-white text-sm hover:bg-gradient-to-r hover:from-green-600/20 hover:to-emerald-600/20 transition-all font-bold flex items-center gap-2">
                  <span>💎</span>
                  <span className="group-hover:translate-x-1 transition-transform">Befektető</span>
                </Link>
                <Link to="/top-5-projektek" onClick={() => setEszkozokOpen(false)} className="group block px-5 py-3 text-white text-sm hover:bg-gradient-to-r hover:from-green-600/20 hover:to-emerald-600/20 transition-all font-bold flex items-center gap-2">
                  <span>🔥</span>
                  <span className="group-hover:translate-x-1 transition-transform">Top 5 Projektek</span>
                </Link>
                <div className="border-t border-white/20 my-2"></div>
                <button onClick={() => { onArKalkulatorOpen(); setEszkozokOpen(false); }} className="group w-full text-left block px-5 py-3 text-white text-sm hover:bg-gradient-to-r hover:from-green-600/20 hover:to-emerald-600/20 transition-all flex items-center gap-2">
                  <span>🧮</span>
                  <span className="group-hover:translate-x-1 transition-transform">Árkalkulátor</span>
                </button>
                <button onClick={() => { onModalOpen('affiliate'); setEszkozokOpen(false); }} className="group w-full text-left block px-5 py-3 text-white text-sm hover:bg-gradient-to-r hover:from-green-600/20 hover:to-emerald-600/20 transition-all flex items-center gap-2">
                  <span>🤝</span>
                  <span className="group-hover:translate-x-1 transition-transform">Ajánlói program</span>
                </button>
              </div>
            )}
          </div>
          
          {/* Rólunk */}
          <Link to="/rolunk" className="px-3 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-xl border border-white/20 hover:border-white/40 text-white font-semibold text-xs rounded-lg transition-all duration-300 whitespace-nowrap no-underline hover:scale-105">
            ℹ️ Rólunk
          </Link>
          
          {/* Kapcsolat */}
          <Link to="/kapcsolat" className="px-3 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-xl border border-white/20 hover:border-white/40 text-white font-semibold text-xs rounded-lg transition-all duration-300 whitespace-nowrap no-underline hover:scale-105">
            📞 Kapcsolat
          </Link>
        </div>
        
        {/* Language selector and Auth menu - right side */}
        <div className="hidden xl:flex items-center gap-2 flex-shrink-0">
          <NavbarLanguageSelector />
          <UserAuthMenu />
        </div>
        
        {/* Hamburger icon for mobile/tablet */}
        <button
          className="xl:hidden flex items-center justify-center text-white p-2 focus:outline-none z-10"
          onClick={onMobileMenuOpen}
          aria-label="Menü megnyitása"
          id="mobile-menu-open-btn"
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="18" x2="21" y2="18" /></svg>
        </button>
        </nav>
      </div>
    </header>
  );
}

function Hero({ setOfferRequestOpen }) {
  const { dict } = useLanguage();
  return (
    <section className="relative w-full h-[340px] md:h-[500px] lg:h-[600px] flex items-center justify-center overflow-hidden bg-[#1a1a1a]">
      {/* Hero Background Video */}
      <video
        src="/hero_video.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover brightness-75"
        poster="/galeria1_ai.jpg"
      />
      <div className="absolute inset-0 bg-black bg-opacity-70 flex flex-col items-center justify-center px-4">
        <h1 className="text-lg sm:text-xl md:text-2xl lg:text-4xl font-extrabold text-white mb-4 text-center drop-shadow-lg leading-tight max-w-full">
          Mobilházak Mercedese – Trabant áron
        </h1>
        <p className="text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed max-w-4xl text-center text-gray-200 mb-8 px-2">
          Kulcsrakész prémium mobilház raktárról – azonnal, megbízhatóan, akár teljes felszereltséggel és további extrákkal. <span className="font-bold text-yellow-400">Nettó 370.000 HUF / nettó m²</span> kulcsrakészen!
        </p>
        
        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8">
          <button
            onClick={() => setOfferRequestOpen(true)}
            className="bg-secondary hover:bg-hover text-white font-bold px-6 py-3 rounded-md text-base shadow-lg transition-all duration-200"
          >
            Ingyenes ajánlatkérés
          </button>
          <button
            onClick={() => window.location.href = '/arkalkulator'}
            className="bg-transparent hover:bg-secondary/10 text-white font-bold px-6 py-3 rounded-md text-base shadow-lg border-2 border-secondary transition-all duration-200"
          >
            Árkalkulátor
          </button>
        </div>

        {/* Promotion Banner */}
        <div className="relative bg-white/10 backdrop-blur-xl rounded-lg p-4 max-w-sm mx-auto shadow-lg border border-white/20">
          <div className="relative text-center">
            <div className="flex items-center justify-center gap-2 mb-3">
              <span className="text-lg animate-bounce">🚀</span>
              <h3 className="text-sm sm:text-base font-bold text-white drop-shadow-lg leading-tight">
                Indul a HoppHomes – Legyél te is az elsők között!
              </h3>
              <span className="text-lg animate-bounce" style={{animationDelay: '0.5s'}}>🚀</span>
            </div>
            <p className="text-white/95 text-xs sm:text-sm mb-3 leading-relaxed drop-shadow-md">
              Regisztrálj most, és kapsz <span className="font-bold text-yellow-400 bg-yellow-400/20 px-1 rounded">5 ingyenes ingatlanfeltöltést</span> a nyitáskor!
            </p>
            <div className="bg-white/15 backdrop-blur-sm rounded-lg p-2 mb-3 border border-white/20">
              <p className="text-white text-xs font-medium drop-shadow-sm">
                ⏰ Korlátozott ajánlat – 2026. január 31-ig
              </p>
            </div>
            <a 
              href="/affiliateregister" 
              className="inline-block bg-secondary hover:bg-hover text-white font-bold px-4 py-2 rounded-md text-sm shadow-lg transition-all duration-200 transform hover:scale-105"
            >
              🎁 Ingyenes regisztráció
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function Elonyok({ onVideoGalleryOpen }) {
  const { dict } = useLanguage();
  return (
    <section id="elonyok" className="py-20 bg-[#18181b]">
      <div className="w-full px-6 md:px-12 mx-auto flex flex-col md:flex-row justify-center items-stretch text-center gap-y-10 md:gap-y-0 md:gap-4">
        <div className="flex flex-col items-center justify-center bg-[#23272f] border border-white/10 rounded-2xl shadow-lg px-6 py-8 md:px-7 md:py-10 w-72">
          <span className="text-5xl mb-3">⏱️</span>
          <span className="font-bold text-base md:text-lg text-white mb-2 uppercase tracking-wider whitespace-pre-line break-words leading-tight" style={{lineHeight:'1.15'}}>{(dict.elonyok?.fastTitle || "GYORS KIVITELEZÉS").toUpperCase()}</span>
          <p className="text-gray-400 text-sm md:text-base leading-relaxed mt-1">{dict.elonyok?.fastDesc || "Rövid időn belül beköltözhetsz új, modern otthonodba – hosszú várakozás nélkül, kompromisszumok nélkül."}</p>
        </div>
        <div className="flex flex-col items-center justify-center bg-[#23272f] border border-white/10 rounded-2xl shadow-lg px-6 py-8 md:px-7 md:py-10 w-72">
          <span className="text-5xl mb-3">🏠</span>
          <span className="font-bold text-base md:text-lg text-white mb-2 uppercase tracking-wider whitespace-pre-line break-words leading-tight" style={{lineHeight:'1.15'}}>{(dict.elonyok?.designTitle || "MODERN DIZÁJN").toUpperCase()}</span>
          <p className="text-gray-400 text-sm md:text-base leading-relaxed mt-1">{dict.elonyok?.designDesc || "Letisztult, skandináv stílus, prémium anyagok, személyre szabható belső tér."}</p>
        </div>
        <div className="flex flex-col items-center justify-center bg-[#23272f] border border-white/10 rounded-2xl shadow-lg px-6 py-8 md:px-7 md:py-10 w-72">
          <span className="text-5xl mb-3">🌿</span>
          <span className="font-bold text-base md:text-lg text-white mb-2 uppercase tracking-wider whitespace-pre-line break-words leading-tight" style={{lineHeight:'1.15'}}>{(dict.elonyok?.ecoTitle || "ENERGIATAKARÉKOS").toUpperCase()}</span>
          <p className="text-gray-400 text-sm md:text-base leading-relaxed mt-1">{dict.elonyok?.ecoDesc || "Kiemelkedő szigetelés, alacsony rezsi, fenntartható technológiák."}</p>
        </div>
        <TiktokPromoBlock className="w-72" />
        <VideoGalleryPromoBlock onOpen={onVideoGalleryOpen} className="w-72" />
      </div>
    </section>
  );
}
      <footer>
        <div>&copy; {new Date().getFullYear()} Hopp Homes | Minden jog fenntartva.</div>
      </footer>

function Home({ onMuszakiModalOpen, onModalOpen, offerRequestOpen, setOfferRequestOpen, onArKalkulatorOpen, showAffiliateSection, setShowAffiliateSection }) {

  const [muszakiModalOpen, setMuszakiModalOpen] = useState(false);
  const [videoGalleryOpen, setVideoGalleryOpen] = useState(false);
  return (
    <>

      <div className="bg-black text-white min-h-screen">

      {/* NEW PLATFORM HERO - Iránytű, nem terméklista */}
      <PlatformHero />
      
      {/* Solutions Section - 4 fő megoldás kártyák */}
      <SolutionsSection />
      
      {/* Trust/Stats Section */}
      <StatsSection />
      
      {/* Why Us */}
      <WhyUsSection data-aos="fade-up" />
      
      {/* Affiliate Program */}
      <AffiliateSection data-aos="fade-up" />
      
      {/* Contact */}
      <ContactSection data-aos="fade-up" />
      
      <Footer />
    </div>
    </>
  );
}


function MaintenanceWrapper({ children }) {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    checkMaintenanceStatus();
  }, []);

  const checkMaintenanceStatus = async () => {
    try {
      console.log('🔄 Checking maintenance mode status...');
      
      // Check if user is admin
      const currentUser = auth.currentUser;
      if (currentUser) {
        const adminEmails = ['admin@hopphomes.hu', 'steve@hopphomes.hu'];
        setIsAdmin(adminEmails.includes(currentUser.email));
      }
      
      // Check maintenance mode from Firestore
      const maintenanceDoc = await getDocs(query(collection(db, 'system_settings'), where('key', '==', 'maintenance_mode')));
      
      if (!maintenanceDoc.empty) {
        const status = maintenanceDoc.docs[0].data().value;
        setMaintenanceMode(status);
        console.log('✅ Maintenance mode status:', status);
      } else {
        console.log('📝 No maintenance mode setting found, defaulting to false');
        setMaintenanceMode(false);
      }
    } catch (error) {
      console.error('❌ Error checking maintenance status:', error);
      setMaintenanceMode(false);
    } finally {
      setLoading(false);
    }
  };

  // Show loading while checking maintenance status
  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white text-xl">Betöltés...</div>
      </div>
    );
  }

  // Check if current path is admin-related (always allow admin access)
  const currentPath = window.location.pathname;
  const isAdminPath = currentPath.startsWith('/admin');

  // Show maintenance page if maintenance mode is enabled, user is not admin, and not on admin path
  if (maintenanceMode && !isAdmin && !isAdminPath) {
    return <MaintenancePage />;
  }

  // Show normal app content
  return children;
}

function AppContent() {
  useEffect(() => { initAOS(); }, []);

  // SEO meta
  const metaTitle = 'HoppHomes Prémium Mobilházak – Kulcsrakész, Modern Otthonok';
  const metaDesc = 'Prémium mobilházak, kulcsrakész kivitelben, azonnal beköltözhetően. Modern dizájn, energiatakarékos megoldások, ajánlói rendszer, árkalkulátor, galéria, vélemények és blog a HoppHomes-nál.';

  const [videoGalleryOpen, setVideoGalleryOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [arKalkulatorOpen, setArKalkulatorOpen] = useState(false);
  const [chatbotOpen, setChatbotOpen] = useState(false);
  const [muszakiModalOpen, setMuszakiModalOpen] = useState(false);
  const [modalState, setModalState] = useState(null);
  const [offerRequestOpen, setOfferRequestOpen] = useState(false);
  const [showAffiliateSection, setShowAffiliateSection] = useState(false);
  const { dict } = useLanguage();

  const modalTitles = {
    miert: dict.menu?.why || 'Miért a HoppHomes?',
    tartalmaz: dict.menu?.faq || 'Gyakori Kérdések',
    affiliate: dict.menu?.affiliate || 'Ajánlói program',
    kapcsolat: dict.menu?.contact || 'Kapcsolat',
  };

  const onMuszakiModalOpen = () => setMuszakiModalOpen(true);
  const onMuszakiModalClose = () => setMuszakiModalOpen(false);
  const onModalOpen = (modal) => setModalState(modal);
  const onModalClose = () => setModalState(null);

  return (
    <Router>
      <MaintenanceWrapper>
        <ActivityTracker>
          <DarkLayout>
          <Routes>
        <Route path="/" element={<HOPPHomesHome />} />
        <Route path="/home-old" element={<Home 
        onMuszakiModalOpen={onMuszakiModalOpen}
        onModalOpen={onModalOpen}
        offerRequestOpen={offerRequestOpen}
        setOfferRequestOpen={setOfferRequestOpen}
        onArKalkulatorOpen={setArKalkulatorOpen}
        showAffiliateSection={showAffiliateSection}
        setShowAffiliateSection={setShowAffiliateSection}
      />} />
        <Route path="/affiliateregister" element={<AffiliateRegister />} />
        <Route path="/signup" element={<AffiliateRegister />} />
        <Route path="/hopphomes" element={<HOPPHomesHome />} />
        <Route path="/hoppx-sajat-ingatlan" element={<PropertyUpload />} />
        <Route path="/property-upload" element={<PropertyUpload />} />
        <Route path="/property-success" element={<PropertySuccess />} />
        <Route path="/property-landing" element={<PropertyLandingPage />} />
        <Route path="/epitkezes" element={<EpitkezesFlow />} />
        <Route path="/telek" element={<TelekFlow />} />
        <Route path="/elado-ingatlanok" element={<PropertyListings />} />
        <Route path="/hot-deals" element={<HotDealsSection />} />
        <Route path="/secret-deals" element={<HotDealsSection />} />
        <Route path="/affiliate/dashboard" element={
          <ProtectedAffiliateRoute>
            <AffiliateDashboardPage />
          </ProtectedAffiliateRoute>
        } />
        <Route path="/admin/dashboard" element={<Navigate to="/admin/super" replace />} />
        <Route path="/admin/super" element={
          <ProtectedAdminRoute>
            <SuperAdminDashboard />
          </ProtectedAdminRoute>
        } />
        <Route path="/admin/user-management" element={
          <ProtectedAdminRoute>
            <AdvancedUserManagement />
          </ProtectedAdminRoute>
        } />
        <Route path="/admin/promo-reports" element={
          <ProtectedAdminRoute>
            <AdminPromoReports />
          </ProtectedAdminRoute>
        } />
        <Route path="/impresszum" element={<Impresszum />} />
        <Route path="/jogi-nyilatkozat" element={<JogiNyilatkozat />} />
        <Route path="/kapcsolat" element={<KapcsolatOldal />} />
        <Route path="/kesz-hazak" element={<KeszHazak />} />
        <Route path="/ajanlat" element={<Ajanlat />} />
        <Route path="/hoppsolid" element={<HoppSolid />} />
        <Route path="/kesz-hazak/:slug" element={<KeszHazModel />} />
        <Route path="/egyedi-hazak" element={<EgyediHazak />} />
        <Route path="/mobilhazak" element={<MobilhazakPage />} />
        <Route path="/hopp-proconcept" element={<HoppProConcept />} />
        <Route path="/hopp-proconcept/:slug" element={<HoppProConceptModel />} />
        <Route path="/hopp-proconcept/viablokk" element={<HoppProConceptViablokk />} />
        <Route path="/ingatlan-piac" element={<IngatlanPiac />} />
        <Route path="/ai-transform" element={<AIPropertyTransform />} />
        <Route path="/befekteto" element={<InvestorDashboard />} />
        <Route path="/top-5-projektek" element={<Top5ProjectsWeekly />} />
        <Route path="/rolunk" element={<MiertHoppHomes />} />
        <Route path="/kedvencek" element={<HamarosaanPage title="Kedvencek" description="A kedvenc ingatlanaid hamarosan egy helyen lesznek. Kövess meg egy ingatlant a szív ikonra kattintva!" />} />
        <Route path="/ertesitesek" element={<HamarosaanPage title="Értesítések" description="Az ingatlan értesítések hamarosan élesen működnek. Adj meg keresési feltételeket és értesítünk az új ajánlatokról!" />} />
        <Route path="/arkalkulator" element={<HamarosaanPage title="Árkalkulátor" description="Az árkalkulátor hamarosan elérhető lesz mint önálló oldal. Addig használd a lebegő kalkulátor gombot!" />} />
      </Routes>
      <Modal open={arKalkulatorOpen} onClose={() => setArKalkulatorOpen(false)} onBack={() => setArKalkulatorOpen(false)} title="Árkalkulátor">
        <ArKalkulatorModalContent />
      </Modal>
      <Modal open={muszakiModalOpen} onClose={() => setMuszakiModalOpen(false)} onBack={() => setMuszakiModalOpen(false)}>
        <MuszakiModalContent />
      </Modal>
{modalState === 'tartalmaz' && (
  <Modal open={true} onClose={onModalClose} onBack={onModalClose} title="Gyakori Kérdések">
    <MitTartalmaz />
  </Modal>
)}
{modalState === 'miert' && (
  <Modal open={true} onClose={onModalClose} onBack={onModalClose} title="Miért a HoppHomes?">
    <MiertModuLive />
  </Modal>
)}
{modalState === 'kapcsolat' && (
  <Modal open={true} onClose={onModalClose} onBack={onModalClose} title="Kapcsolat">
    <KapcsolatForm />
  </Modal>
)}


      
      {/* OfferRequestModal - open when offerRequestOpen is true */}
      {offerRequestOpen && (
        <Modal open={true} onClose={() => setOfferRequestOpen(false)} onBack={() => setOfferRequestOpen(false)} title="Ingyenes árajánlat">
          <OfferRequestModal onClose={() => setOfferRequestOpen(false)} />
        </Modal>
      )}
          
          {/* Global UI Components */}
          <ScrollToTop />
          <CookieConsent />
          </DarkLayout>
        </ActivityTracker>
      </MaintenanceWrapper>
    </Router>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}
